export default abstract class IPickListItem {

    abstract get key(): string;

    abstract get descricao(): string;
}